import { NgModule } from "@angular/core";
import { DepositMainModule } from "./cashier/deposit/deposit-main/deposit-main.module";
import { ForgotPasswordModule } from "./forgot-password/forgot-password.module";
import { LoginModule } from "./login/login.module";
import { PlayerProtectionModule } from "./responsible-gaming/player-protection/player-protection.module";
import { SignupStepTwoModule } from "./signup-step-two/signup-step-two.module";
import { IdologyKbaModule } from "./idology-kba/idology-kba.module";
import { SmsLoginModule } from "./sms-login/sms-login.module";
import { UpdatePhoneNumberModule } from "./update-phone-number/update-phone-number.module";
import { DepositCreditcardModule } from "./cashier/deposit/deposit-creditcard/deposit-creditcard.module";
import { DepositCageModule } from "./cashier/deposit/deposit-cage/deposit-cage.module";
import { DepositVipModule } from "./cashier/deposit/deposit-vip/deposit-vip.module";
import { DepositPaypalModule } from "./cashier/deposit/deposit-paypal/deposit-paypal.module";
import { AccountInformationModule } from "./information-and-security/account-information/account-information.module";
import { PersonalInformationModule } from "./information-and-security/personal-information/personal-information.module";
import { UploadDocumentModule } from "./information-and-security/upload-document/upload-document.module";
import { ChangePasswordModule } from "./information-and-security/change-password/change-password.module";
import { LimitsModule } from "./limits/limits.module";
import { SecurityQuestionModule } from "./information-and-security/security-question/security-question.module";
import { ResendPinModule } from "./information-and-security/resend-pin/resend-pin.module";
import { AccountBalanceModule } from "./account-balance/account-balance.module";
import { RafInviteEmailModule } from "./refer-a-friend/raf-invite-email/raf-invite-email.module";
import { RafOverviewModule } from "./refer-a-friend/raf-overview/raf-overview.module";
import { CashierBaseModule } from "./cashier/cashier-base/cashier-base.module";
import { ActiveBonusesModule } from "./rewards/bonuses/active-bonuses/active-bonuses.module";
import { BonusOffersModule } from "./rewards/bonuses/bonus-offers/bonus-offers.module";
import { PastBonusesModule } from "./rewards/bonuses/past-bonuses/past-bonuses.module";
import { WithdrawalPaypalModule } from "./cashier/withdraw/withdrawal-paypal/withdrawal-paypal.module";
import { WithdrawalPrepaidModule } from "./cashier/withdraw/withdrawal-prepaid/withdrawal-prepaid.module";
import { WithdrawalVipModule } from "./cashier/withdraw/withdrawal-vip/withdrawal-vip.module";
import { WithdrawalBaseModule } from "./cashier/withdraw/withdrawal-base/withdrawal-base.module";
import { WithdrawalCageModule } from "./cashier/withdraw/withdrawal-cage/withdrawal-cage.module";
import { WithdrawalReverseModule } from "./cashier/withdraw/withdrawal-reverse/withdrawal-reverse.module";
import { TransactionHistoryModule } from "./cashier/transaction-history/transaction-history.module";
import { AppUpdateModule } from "./app-update/app-update.module";
//import { AppRestrictedModule } from "./app-restricted/app-restricted.module";
import { DepositPaynearmeModule } from "./cashier/deposit/deposit-paynearme/deposit-paynearme.module";
import { DepositPlayplusModule } from "./cashier/deposit/deposit-playplus/deposit-playplus.module";
import { DepositSuccessFailureModule } from "./cashier/deposit/deposit-success-failure/deposit-successfailure.module";
import { DepositPaywithmybankModule } from "./cashier/deposit/deposit-paywithmybank/deposit-paywithmybank.module";
import { BonusDetailsModule } from "./rewards/bonuses/bonus-details/bonus-details.module";
import { CoolOffModule } from "./cool-off/cool-off.module";
import { StrongAuthenticationModule } from "./information-and-security/strong-authentication/strong-authentication.module";

import { GameSettingsModule } from "./information-and-security/game-settings/game-settings.module";
import { RedeemBonusCodeModule } from "./rewards/bonuses/redeem-bonus-code/redeem-bonus-code.module";
import { WithdrawalReverseConfirmModule } from "./cashier/withdraw/withdrawal-reverse-confirm/withdrawal-reverse-confirm.module";
import { RiskFreeBetRiskModule } from "./rewards/bonuses/risk-free-bet-risk/risk-free-bet-risk.module";
import { TotalWithdrawalsModule } from "./cashier/overview/total-withdrawals/total-withdrawals.module";
import { TotalDepositsModule } from "./cashier/overview/total-deposits/total-deposits.module";
import { RejectedWithdrawalsModule } from "./cashier/overview/rejected-withdrawals/rejected-withdrawals.module";
import { PendingWithdrawalsModule } from "./cashier/overview/pending-withdrawals/pending-withdrawals.module";
import { WithdrawalMailModule } from "./cashier/withdraw/withdrawal-mail/withdrawal-mail.module";
import { AccountSummaryModule } from "./account-summary/account-summary.module";
import { TaxReportsModule } from "./tax-reports/tax-reports.module";
import { WinLossModule } from "./cashier/win-loss/win-loss.module";
import { MyFreeSpinModule } from "./rewards/bonuses/my-free-spin/my-free-spin.module";
import { SelfExcludeModule } from "./self-exclude/self-exclude.module";
import { GameTransactionsModule } from "./game-transactions/game-transactions.module";
import { DailySlotModule } from "./daily-slot/daily-slot.module";
import { WithdrawalPayWithMyBankModule } from "./cashier/withdraw/withdrawal-pay-with-my-bank/withdrawal-pay-with-my-bank.module";
import { DepositThresholdModule } from "./cashier/deposit/deposit-threshold/deposit-threshold.module";
import { CasinoHistoryPageModule } from "./game-history/game-history.module";
import { DeleteAccountModule } from "./delete-account/delete-account.module";
import { InvalidKycModule } from "./invalid-kyc/invalid-kyc.module";
import { CamsModule } from "./cams/cams.module";
import { IdNowModule } from "./id-now/id-now.module";
import { SignupResultModule } from "./signup-result/signup-result.module";
import { ManageNotificationsModule } from "./information-and-security/manage-notifications/manage-notifications.module";
import { MyTransactionMethodsModule } from "./my-transaction-methods/my-transaction-methods.module";
import { DepositPayWithCash } from "./cashier/deposit/deposit-pay-with-cash/deposit-pay-with-cash.module";
import { UpdateTocComponentModule } from "./update-toc/update-toc.module";
import { UpdatePrivacyPolicyModule } from "./update-privacy-policy/update-privacy-policy.module";
import { UpdateHouseRulesModule } from "./update-house-rules/update-house-rules.module";
import { ResetPasswordModule } from "./reset-password/reset-password.module";
import { CoolingOffModule } from "./cooling-off/cooling-off.module";
import { ExternalLinkContentModule } from "./external-link-content/external-link-content.module";
import { PasswordResetModule } from "./password-reset/password-reset.module";
import { PlayerMigrationModule } from "./player-migration/player-migration.module";
import { DepositWireModule } from "./cashier/deposit/deposit-wire/deposit-wire.module";
//import { BoydRewardsConnectModule } from "./boyd-rewards/boyd-rewards-connect/boyd-rewards-connect.module";
import { BoydMyBalanceModule } from "./boyd-rewards/boyd-my-balance/boyd-my-balance.module";
import { EnrollBoydRewardsModule } from "./boyd-rewards/enroll-boyd-rewards/enroll-boyd-rewards.module";
import { BoydRedeemRewardsModule } from "./boyd-rewards/boyd-redeem-rewards/boyd-redeem-rewards.module";
import { ContentPlaceholderModule } from "./content-placeholder/content-placeholder.module";
import { DepositInstaDebitActionPageModule } from "./cashier/deposit/deposit-instadebit-action/deposit-instadebit-action.module";
import { DepositInstaDebitPageModule } from "./cashier/deposit/deposit-instadebit/deposit-instadebit.module";
import { DepositIDebitPageModule } from "./cashier/deposit/deposit-idebit/deposit-idebit.module";
import { DepositIDebitActionPageModule } from "./cashier/deposit/deposit-idebit-action/deposit-idebit-action.module";
import { DepositECheckPageModule } from "./cashier/deposit/deposit-e-check/deposit-e-check.module";
import { DepositECheckAddPageModule } from "./cashier/deposit/deposit-e-check-add/deposit-e-check-add.module";
import { DepositECheckBasePageModule } from "./cashier/deposit/deposit-e-check-base/deposit-e-check-base.module";
import { DepositNeosurfModule } from "./cashier/deposit/deposit-neosurf/deposit-neosurf.module";
import { DepositInteracPageModule } from "./cashier/deposit/deposit-interac/deposit-interac.module";
import { DepositInteracActionPageModule } from "./cashier/deposit/deposit-interac-action/deposit-interac-action.module";
import { WithdrawalECheckPageModule } from "./cashier/withdraw/withdrawal-echeck/withdrawal-echeck.module";
import { WithdrawalECheckAddPageModule } from "./cashier/withdraw/withdrawal-echeck-add/withdrawal-echeck-add.module";
import { WithdrawalIDebitPageModule } from "./cashier/withdraw/withdrawal-idebit/withdrawal-idebit.module";
import { WithdrawalInstaDebitPageModule } from "./cashier/withdraw/withdrawal-instadebit/withdrawal-instadebit.module";
import { WithdrawalInteracModule } from "./cashier/withdraw/withdrawal-interac/withdrawal-interac.module";
import { WithdrawalInteracAddModule } from "./cashier/withdraw/withdrawal-interac-add/withdrawal-interac-add.module";
import { PiggyBankModule } from "./piggy-bank/piggy-bank.module";
import { LeaderboardModule } from "./leaderboard/leaderboard.module";
import { ShopPageModule } from "./shop-page/shop-page.module";
import { SettingsModule } from "./settings/settings.module";
import { AvatarModule } from "./avatar/avatar.module";
import { LeaderboardCongratsPopupModule } from "./leaderboard-congrats-popup/leaderboard-congrats-popup.module";
import { LeaderboardNicknamePopupPageModule } from "./leaderboard-nickname-popup/leaderboard-nickname-popup.module";
import { LeaderboardMyavataPopupPageModule } from "./leaderboard-myavata-popup/leaderboard-myavata-popup.module";
import { GameDetailModule } from "./game-detail-page/game-detail.module";
import { ContestModule } from "./contest/contest.module";
import { LeaderboardTutorialModule } from "./leaderboard/leaderboard-tutorial/leaderboard-tutorial.module";
import { LeaderboardEndCongratsPopupModule } from "./leaderboard/leaderboard-end-congrats/leaderboard-end-congrats.module";
import { DownloadAppsModule } from "./download-apps/download-apps.module";
import { SiteMenuModule } from "./site-menu/site-menu.module";
import { SignupRedirectModule } from "./signup-redirect/signup-redirect.module";
import { SignupOptionsStepOneModule } from "./signup-options-step-one/signup-options-step-one.module";
import { SignupOptionsStepTwoModule } from "./signup-options-step-two/signup-options-step-two.module";
import { AlertNotificationModule } from "./alert-notification/alert-notification.module";

@NgModule({
  imports: [
    AccountBalanceModule,
    ActiveBonusesModule,
    AccountInformationModule,
    AppUpdateModule,
    //AppRestrictedModule,
    BonusDetailsModule,
    BonusOffersModule,
   //BoydRewardsConnectModule,
    BoydMyBalanceModule,
    BoydRedeemRewardsModule,
    PersonalInformationModule,
    UploadDocumentModule,
    CashierBaseModule,
    ContentPlaceholderModule,
    DailySlotModule,
    DepositCageModule,
    DepositCreditcardModule,
    DepositMainModule,
    DepositPaynearmeModule,
    DepositPaypalModule,
    DepositPaywithmybankModule,
    DepositPlayplusModule,
    DepositIDebitPageModule,
    DepositIDebitActionPageModule,
    DepositECheckPageModule,
    DepositECheckAddPageModule,
    DepositECheckBasePageModule,
    DepositInteracPageModule,
    DepositInteracActionPageModule,
    DepositNeosurfModule,
    DepositVipModule,
    DepositSuccessFailureModule,
    DepositInstaDebitActionPageModule,
    DepositInstaDebitPageModule,
    DepositThresholdModule,
    DepositWireModule,
    LeaderboardTutorialModule,
    ForgotPasswordModule,
    LoginModule,
    RedeemBonusCodeModule,
    RiskFreeBetRiskModule,
    SignupOptionsStepOneModule,
    SignupOptionsStepTwoModule,
    SignupStepTwoModule,
    SignupResultModule,
    SiteMenuModule,
    IdologyKbaModule,
    InvalidKycModule,
    CamsModule,
    IdNowModule,
    LeaderboardEndCongratsPopupModule,
    PlayerProtectionModule,
    PastBonusesModule,
    ChangePasswordModule,
    ResendPinModule,
    LimitsModule,
    MyFreeSpinModule,
    PendingWithdrawalsModule,
    SecurityQuestionModule,
    TransactionHistoryModule,
    TaxReportsModule,
    TotalWithdrawalsModule,
    TotalDepositsModule,
    RafInviteEmailModule,
    RafOverviewModule,
    RejectedWithdrawalsModule,
    WithdrawalPaypalModule,
    WithdrawalPrepaidModule,
    WithdrawalECheckPageModule,
    WithdrawalECheckAddPageModule,
    WithdrawalVipModule,
    WithdrawalCageModule,
    WithdrawalBaseModule,
    WithdrawalReverseModule,
    WithdrawalReverseConfirmModule,
    WithdrawalIDebitPageModule,
    WithdrawalInstaDebitPageModule, 
    WithdrawalInteracModule, 
    WithdrawalInteracAddModule, 
    StrongAuthenticationModule,
    WithdrawalPayWithMyBankModule,
    WithdrawalMailModule,
    WinLossModule,
    GameSettingsModule,
    CoolOffModule,
    AccountSummaryModule,
    SelfExcludeModule,
    GameTransactionsModule,
    SmsLoginModule,
    UpdatePhoneNumberModule,
    CasinoHistoryPageModule,
    DeleteAccountModule,
    ManageNotificationsModule,
    MyTransactionMethodsModule,
    UpdateTocComponentModule,
    UpdatePrivacyPolicyModule,
    UpdateHouseRulesModule,
    DepositPayWithCash,
    ResetPasswordModule,
    CoolingOffModule,
    ExternalLinkContentModule,
    PasswordResetModule,
    PlayerMigrationModule,
    EnrollBoydRewardsModule,
    PiggyBankModule,
    LeaderboardModule,
    LeaderboardCongratsPopupModule,
    ShopPageModule,
    SettingsModule,
    AvatarModule,
    LeaderboardNicknamePopupPageModule,
    LeaderboardMyavataPopupPageModule,
    GameDetailModule,
    ContestModule,
    DownloadAppsModule,
    SignupRedirectModule,
    AlertNotificationModule
  ],
})
export class pagesModule { }
